/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_All_DescInputs */



/**
* | output |
* | --- |
* | "all submitted decklists" |
*
* @param {Og_Cfg_All_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_all_desc = /** @type {((inputs?: Og_Cfg_All_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_All_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("toutes les listes de decks soumises")
	if (locale === "es") return /** @type {LocalizedString} */ ("todas las listas enviadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("todas as listas de deck enviadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("tutte le liste dei mazzi inviate")
	return /** @type {LocalizedString} */ ("all submitted decklists")
});